module.exports = __webpack_public_path__ + "static/media/Other_Services.a2c130c6.jpg";